import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.26209 16L10 13.3697V2H9.92317L8.23415 7.03471C8.20681 7.11619 8.13048 7.1711 8.04454 7.1711L2.25637 7.1711C2.06108 7.1711 1.98157 7.42228 2.14128 7.53466L6.81288 10.822C6.88523 10.8729 6.91554 10.9653 6.8874 11.0492L5.22652 16H6.26209Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.03506 6.92614L9.75977 1.61804L11.4845 6.92614C11.5782 7.21456 11.847 7.40983 12.1502 7.40983H17.7315L13.2161 10.6904C12.9708 10.8687 12.8681 11.1846 12.9619 11.473L14.6866 16.7812L10.1712 13.5006C9.92587 13.3223 9.59366 13.3223 9.34832 13.5006L4.83297 16.7812L6.55768 11.473C6.65139 11.1846 6.54873 10.8687 6.30339 10.6904L1.78804 7.40983H7.36932C7.67258 7.40983 7.94135 7.21456 8.03506 6.92614Z",
  stroke: "currentColor",
  fill: "none"
})), 'StarHalf', {
  viewBox: '0 0 20 18'
});